import React from "react";
import Reveal from "../Reveal";
import { PROCESS_STEPS, IMG } from "../../../lib/site";

const ProcessSteps = () => (
  <section className="py-20 md:py-24 bg-zinc-950 border-y border-zinc-900" data-testid="process-section">
    <div className="max-w-7xl mx-auto px-5 lg:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center mb-14">
        <div className="lg:col-span-7">
          <span className="text-[#C69453] text-sm font-semibold tracking-[0.2em] uppercase">Our Process</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-white mt-2 leading-tight">
            A Premium Floor Is 90% Preparation
          </h2>
          <p className="text-zinc-400 text-base md:text-lg mt-4 leading-relaxed">
            Cheap contractors roll thin paint over dusty concrete and it peels within months. We follow a disciplined,
            five-step process so your floor bonds permanently and looks flawless for decades.
          </p>
        </div>
        <div className="lg:col-span-5">
          <div className="aspect-[4/3] overflow-hidden border border-zinc-800">
            <img src={IMG.processGrind} alt="Diamond grinding concrete preparation" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5">
        {PROCESS_STEPS.map((s, i) => (
          <Reveal key={s.step} delay={i * 0.06}>
            <div className="border border-zinc-800 bg-[#141414] p-6 h-full">
              <span className="text-[#C69453] font-heading text-3xl font-bold">{s.step}</span>
              <h3 className="text-lg font-bold text-white mt-3">{s.title}</h3>
              <p className="text-zinc-400 text-sm mt-2 leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default ProcessSteps;
